import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

import img from '../../docs/fondGris.png';
import photo from '../../docs/nature2.png';

export default function ContactHeader() {
  const { currentUser, navigateTo, setInterfaceType } = useContext(BaseContext);

  return (
    <header className="section-contacts-header">
      <div className="current-user-profil">
        <div className="current-user-profil--image">
          <img src={ img } alt="img" data-src={ photo } />
          <i className="bi bi-dot icon-status"></i>
        </div>
        <span className="current-user-profil--name">
          { currentUser.nom }
        </span>
      </div>
      <div className="section-contacts-header-research" onClick={() => setInterfaceType("searchContact")}>
        <i className="bi bi-search" onClick={ () => navigateTo("search-contact") }></i>
      </div>
    </header>
  );
}
